<template>
  <div>
    <LoadingAnim />
  </div>
</template>

<script>
import { get } from 'vuex-pathify';

const DEFAULT_PROJECT_ID = 'defaultProjectId';
const DEFAULT_HOME = 'welcome-home';

export default {
  name: 'LoginView',
  beforeRouteEnter(to, { name, path }, next) {
    next((vm) => {
      // access to component instance via `vm`
      if (to && to.name === 'logout') {
        vm.logout();
      }
      if (!name || name === 'login' || name === 'logout' || name === 'register') {
        // eslint-disable-next-line no-param-reassign
        vm.previousRoute = { name: DEFAULT_HOME };
      } else {
        // eslint-disable-next-line no-param-reassign
        vm.previousRoute = { path };
      }
    });
  },
  data() {
    return {
      error: '',
      previousRoute: { name: DEFAULT_HOME },
    };
  },
  computed: {
    loaded: get('account2/loaded'),
    loading() {
      return this.$auth.isAuthenticated && this.$auth.user && !this.loaded;
    },
  },
  watch: {
    loaded: 'doCheck',
    '$auth.isAuthenticated': 'doCheck',
  },
  mounted() {
    this.doCheck();
  },
  methods: {
    goToRoute(route) {
      const resolved = this.$router.resolve(route);
      if (route.path && resolved.route && !resolved.route.name) {
        window.location.href = route.path;
      } else {
        this.$router.replace(route);
      }
    },
    login() {
      this.$auth.loginWithRedirect({ authorizationParams: { screen_hint: 'login' } });
    },
    loginClicked() {
      this.$auth.loginWithRedirect({
        authorizationParams: { screen_hint: 'login', prompt: 'login' },
      });
    },
    loginForRoute(route) {
      if (!this.$route.query.error) {
        this.$cookies.set('continue-url', route, '1h');
        this.login();
      } else {
        this.error = this.$route.query.error_description;
        this.$route.query.error = '';
      }
    },
    doCheck() {
      if (!this.$auth.loading && (!this.$auth.isAuthenticated || !this.$auth.user)) {
        if (this.$route.query['continue-url']) {
          try {
            // Enforces the continue-url is only ever relative
            const url = new URL(this.$route.query['continue-url']);
            const path = url.toString().substring(url.origin.length);
            this.previousRoute = { path };
          } catch (error) {
            console.log(error);
          }
        }
        this.$nextTick(() => this.loginForRoute(this.previousRoute));
      } else if (this.loaded) {
        if (this.$cookies.isKey('continue-url')) {
          const nextRoute = this.$cookies.get('continue-url');
          this.$cookies.remove('continue-url');
          if (nextRoute && this.$router.currentRoute.path !== nextRoute.path) {
            this.$nextTick(() => this.goToRoute(nextRoute));
          }
        } else {
          this.$nextTick(() => this.goToRoute(this.previousRoute));
        }
      }
    },
    async logout() {
      window.sessionStorage.removeItem(DEFAULT_PROJECT_ID);
      await this.$fetcher.logout().catch((ex) => {
        console.warn(ex);
      });
      await this.$auth.logout({ returnTo: process.env.VUE_APP_AUTH0_REDIRECT_URI });
    },
  },
};
</script>
